import React from 'react';
import ReactDOM from 'react-dom';

import { App, RedirectHgwToUrlConfig } from './components/App/App';

declare global {
  interface Window {
    altibox: {
      auth: {
        isLoggedIn: (fn: Function) => void;
        ssoLogin: () => void;
      };
      apps: {
        gatewayRedirect: { init: (container: Array<HTMLElement> | JQuery, config: RedirectHgwToUrlConfig) => void };
      };
    };
  }
}

window.altibox.apps.gatewayRedirect = {
  init: (container: Array<HTMLElement> | JQuery, config: RedirectHgwToUrlConfig) => {
    ReactDOM.render(<App config={config} />, container[0] || container);
  },
};
